import React from "react";
import '../../../styles/components/onboarding/keyboard-setup/setup-your-keyboard-page.scss';
import Button from "../../common/Button";
import {navigate} from "../../../services/navigation/navigation";
import {appPagePaths} from "../../../config/config";
import OrientationWebpImg from "../../common/OrientationWebpImg";
import handsOnKeyboardPortrait from "./images/hands-on-keyboard-portrait.webp";
import handsOnKeyboardLandscape from "./images/hands-on-keyboard-landscape.webp";
import {keyboardWizardStore} from "../../../redux/keyboardWizard/keyboardWizardStore";
import BackButton from "../../common/BackButton";
import {inAppAnalyticsService} from "../../../services/inAppAnalyticsService";

const screenClass = 'onboarding/setup-your-keyboard';

export default function SetupYourKeyboard() {
  return (
    <div className="setup-your-keyboard-page">
      <header className="top">
        <BackButton analyticsIdentifier={'setup-your-keyboard-back'} analyticsScreenClass={screenClass} />
        <OrientationWebpImg srcPortrait={handsOnKeyboardPortrait} srcLandscape={handsOnKeyboardLandscape}/>
        <div className="overlay-text">
          <h1>Set up your keyboard</h1>
        </div>
      </header>
      <div className="content-and-navigation">
        <main className="content">
          <div className="page-header-text">Set up your keyboard</div>
          <div className="content-header">Set up a keyboard to use all of Playground&apos;s interactive features.</div>
          <div className="info-text">Features include real-time feedback, scores, rewards, and progress tracking.</div>
          <div className="sub-info-text">Requires a USB or MIDI keyboard.</div>
        </main>
        <div className="navigation">
          <div className="buttons">
            <Button buttonType="secondary" text="Start Keyboard Setup" onClick={()=> {
              inAppAnalyticsService.onButton_press('setup-your-keyboard-start-setup', {screenClass});
              keyboardWizardStore.reset();
              navigate(appPagePaths.keyboardWizard);
            }}/>
            <Button buttonType="primary" text="Set Up Keyboard Later" onClick={()=> {
              inAppAnalyticsService.onButton_press('setup-your-keyboard-setup-later', {screenClass});
              navigate(appPagePaths.setupKeyboardLaterPage);
            }} />
          </div>
        </div>
      </div>
    </div>
  );
}